import React, { memo, useContext } from "react";

import Image from "next/image";

import GlobalContext from "shared/providers/context/GlobalContext";

import { Container, ImageWrapper } from "./styles";

const Warranty = () => {
  const { state } = useContext(GlobalContext);

  const site = state.tenancy?.settings.site;

  return (
    <>
      {site?.satisfactionGuaranteeActive === "1" && (
        <Container>
          {site?.satisfactionGuaranteeImage && (
            <ImageWrapper id="satisfactionGuaranteeImage">
              <Image
                width={90}
                height={90}
                src={site?.satisfactionGuaranteeImage}
                alt="satisfactionGuaranteeImage"
              />
            </ImageWrapper>
          )}

          {site?.satisfactionGuaranteeDescription && (
            <span>{site?.satisfactionGuaranteeDescription}</span>
          )}
        </Container>
      )}
    </>
  );
};

export default memo(Warranty);
